import { render, staticRenderFns } from "./pendingOffersTable.vue?vue&type=template&id=7288a332&scoped=true&"
import script from "./pendingOffersTable.vue?vue&type=script&lang=js&"
export * from "./pendingOffersTable.vue?vue&type=script&lang=js&"
import style0 from "./pendingOffersTable.vue?vue&type=style&index=0&id=7288a332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7288a332",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardActions,VCardTitle,VIcon,VListItem,VRow,VSimpleTable})
